/**
 * Created by jv on 09/01/2017.
 */
const utils = require("Sources/utils/utils");
const DataFilter = require("Sources/components/data-filter");
const elementCreator = require("Sources/components/element-creator");
const tableTemplate = require("Sources/templates/fundels-table.template");

//Styles
require("Styles/components/overviews.scss");

/* Usage:
    var tc = new TableCreator({
      headers: headers,                      // Determines which properties of the data are shown
      data: myData,
      rowIdProperty: "id",                   // This is the property that is used to identify the row (must be on the root of the element)
      appendTo: "#append-to-this-element",   // Default: "body"

      this.sortable: false,                  // Default: false (depends on the sort property for the headers)
      this.sortMinLength: 5                  // Default: 5 (if sortable is true, checks if the length is at least this as extra check)
      this.searchable: false,                // Default: false

      // css classes
      wrapperClassName: "wrapper",           // Default: fo-wrapper
      tableClassName: "table",               // Default: fo-table
      headerClassName: "header",             // Default: fo-header
      bodyClassName: "body",                 // Default: fo-body
      rowClassName: "row",                   // Default: fo-row
      cellClassName: "cell",                 // Default: fo-cell

      headerTemplate: myHeaderTemplate,      // Default: defaultHeaderTemplate (see fundels-table-template for example)
      bodyTemplate: mybodyTemplate,          // Default: defaultBodyTemplate (see fundels-table-template for example)

      rowIdProperty: property that can be used as unique id for each row
      onRowClick: whenRowIsClickThisIsCalled  // Default: null (function that is called when a row is clicked, gives the rowIdProperty of the element as parameter 'key')
      onRender: called before each render
      afterRender: called after each render (useful if you want to add custom event listeners)
    });

  tc.create();
 */

module.exports = class TableCreator
{
  constructor(options)
  {
    if(!utils.isArray(options.data))
    {
      throw "options.data must be an Array";
    }

    this.headers = utils.isArray(options.headers) ? options.headers : [];
    this.data = options.data;
    this.filteredData = options.data.slice(0);

    this.appendTo = utils.isNotNull(options.appendTo) ? $(options.appendTo) : $("body");
    this.sortable = utils.isBoolean(options.sortable) ? options.sortable : false;
    this.sortMinLength = utils.isNotNull(options.sortMinLength) ? options.sortMinLength : 5;
    this.searchable = utils.isBoolean(options.searchable) ? options.searchable : false;

    this.wrapperClassName = utils.isNullOrEmpty(options.wrapperClassName) ? "fo-wrapper" : options.wrapperClassName;
    this.tableClassName = utils.isNullOrEmpty(options.tableClassName) ? "fo-table" : options.tableClassName;
    this.headerClassName = utils.isNullOrEmpty(options.headerClassName) ? "fo-header" : options.headerClassName;
    this.bodyClassName = utils.isNullOrEmpty(options.bodyClassName) ? "fo-body" : options.bodyClassName;
    this.rowClassName = utils.isNullOrEmpty(options.rowClassName) ? "fo-row" : options.rowClassName;
    this.cellClassName = utils.isNullOrEmpty(options.cellClassName) ? "fo-cell" : options.cellClassName;

    this.headerTemplate = utils.isFunction(options.headerTemplate) ? options.headerTemplate : tableTemplate.defaultHeaderTemplate;
    this.bodyTemplate = utils.isFunction(options.bodyTemplate) ? options.bodyTemplate : tableTemplate.defaultBodyTemplate;

    //If not null it enforces that this property exists
    this.rowIdProperty = utils.isNullOrEmpty(options.rowIdProperty) ? null : options.rowIdProperty;
    this.onRowClick = utils.isFunction(options.onRowClick) ? options.onRowClick : null;
    this.onRender = utils.isFunction(options.onRender) ? options.onRender : null;
    this.afterRender = utils.isFunction(options.afterRender) ? options.afterRender : null;
  }

  create()
  {
    if(this._initialized !== true)
    {
      var tableElString = elementCreator.createStringElement({
        tagName: "div",
        classNames : [ this.tableClassName ]
      });

      var wrapperElString = elementCreator.createStringElement({
        tagName: "div",
        classNames: [ this.wrapperClassName ],
        innerHTML: tableElString
      });

      this.appendTo.append(wrapperElString);
      this.rerender();

      this._initialized = true;
    }
  }

  reset()
  {
    this.filteredData = this.data.slice(0);
    this.rerender();
  }

  show()
  {
    this.appendTo.show();
  }

  hide()
  {
    this.appendTo.hide();
  }

  rerender(renderHeader)
  {
    if(utils.isFunction(this.onRender))
    {
      this.onRender(this.appendTo);
    }

    if(renderHeader !== false)
    {
      this.renderHeader();
    }

    this.renderBody();

    if(utils.isFunction(this.afterRender))
    {
      this.afterRender(this.appendTo);
    }

    this.show();
  }

  sort(options)
  {
    /*
     * options.sortKey
     * options.sortType = ""
     * options.asc = false;
     */

    options.sortType = utils.isNull(options.sortType) ? "" : options.sortType;
    options.asc = utils.isBoolean(options.asc) ? options.asc : false;

    this.filteredData = DataFilter.sort(this.data, options.sortType, options.sortKey, options.asc);
    this.rerender(false);
  }

  filter(options)
  {
    /*
     * options.property = null
     * options.filterValues = []
     * options.exact = false
     * options.propertyType = "undefined"
     */

    if(this.searchable)
    {
      options = utils.isNotNull(options) ? options : {};
      options.property = utils.isUndefined(options.property) ? null : options.property;
      options.filterValues = utils.isArray(options.filterValues) ? options.filterValues : [];
      options.exact = utils.isBoolean(options.exact) ? options.exact : false;

      this.filteredData = DataFilter.filter(this.data, options.property, options.filterValues, options.exact, options.propertyType);
      this.rerender();
    }
  }

  reload(data)
  {
    utils.devLog("Reloading table with new data: %o", data);

    if(!utils.isArray(data))
    {
      throw "data must be an Array";
    }

    this.data = data;
    this.filteredData = this.data.slice(0);
    this.rerender();
  }

  renderHeader()
  {
    var that = this;

    var mainEl = this.appendTo;
    mainEl.find("." + this.headerClassName).remove();

    if(this.filteredData.length === 0)
    {
      return;
    }

    var tHeader = elementCreator.createStringElement({
      tagName: "div",
      classNames: [ this.headerClassName ],
      innerHTML: this.headerTemplate(this.headers, {
        rowClasses: [ that.rowClassName ],
        cellClasses: [ that.cellClassName, "header" ],
        sortable: this.sortable && this.data.length >= this.sortMinLength
      })
    });

    mainEl.find("." + this.tableClassName).append(tHeader);

    if(this.sortable && this.data.length >= this.sortMinLength)
    {
      mainEl.find("." + this.tableClassName + " ." + this.headerClassName + " .sort-link").off("click").on("click", function(e)
      {
        var thisEl = $(this);
        var sortIcons = thisEl.find(".sort-icons");
        var sortKey = thisEl.attr("data-sort");
        var sortType = thisEl.attr("data-sort-type");
        var sortProperty = thisEl.attr("data-sort-property");
        var asc = false;

        sortKey = utils.isNotNull(sortProperty) ? sortProperty : sortKey;

        if(sortIcons.hasClass("asc"))
        {
          sortIcons.removeClass("asc").addClass("desc");
        }
        else if(sortIcons.hasClass("desc"))
        {
          asc = true;
          sortIcons.removeClass("desc").addClass("asc");
        }
        else
        {
          mainEl.find("." + that.tableClassName + " ." + that.headerClassName + " .sort-link .sort-icons").removeClass("asc desc");
          sortIcons.addClass("desc");
        }

        that.sort({
          sortKey: sortKey,
          sortType: sortType,
          asc: asc
        });

        e.stopPropagation();
      });
    }
  }

  renderBody()
  {
    var that = this;

    var mainEl = this.appendTo;
    mainEl.find("." + this.bodyClassName).remove();

    var headerKeys = this.headers.map(function(el, index)
    {
      return el.key;
    });

    var tBodyRows = "";

    var rowClasses = [ that.rowClassName ];

    if(utils.isFunction(that.onRowClick))
    {
      rowClasses.push("clickable");
    }

    for(var i = 0; i < this.filteredData.length; i++)
    {
      tBodyRows += this.bodyTemplate(headerKeys, this.filteredData[i], {
        rowClasses: rowClasses,
        cellClasses: [ that.cellClassName ],
        rowIdProperty: this.rowIdProperty,
        index: i
      });
    }

    var tBody = elementCreator.createStringElement({
      tagName: "div",
      classNames: [ this.bodyClassName ],
      innerHTML: tBodyRows
    });

    mainEl.find("." + that.tableClassName).append(tBody);

    if(utils.isFunction(that.onRowClick))
    {
      mainEl.find("." + this.tableClassName + " ." + this.bodyClassName + " ." + this.rowClassName).off("click").on("click", function(e)
      {
        var selection = getSelection();

        if(utils.isNullOrEmpty(selection.toString()) || !$.contains(e.target, selection.anchorNode))
        {
          // Only allow row clicks if you're not trying to select text from the row
          var key = $(this).attr("data-row-" + that.rowIdProperty);
          that.onRowClick(key);
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./app/js/components/table-creator.js